/* global axios */
import ApiClient from './ApiClient';

class ConversationExportsApi extends ApiClient {
  constructor() {
    super('conversation_exports', { accountScoped: true });
  }

  getAll() {
    return axios.get(this.url);
  }

  create(params) {
    return axios.post(this.url, params);
  }
}

export default new ConversationExportsApi();
